module.exports = __webpack_public_path__ + "static/img/windows_FAQ_pic06.09a35e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/windows_FAQ/windows_FAQ_pic06.png
// module id = 603
// module chunks = 1